import {
  Button,
  FormGroupControl,
  FormProvider,
  TextareaField,
  useToast,
} from '@kcd/design-system';

import { useTrackClick } from '~/hooks/event';

const WishProductForm = () => {
  const toast = useToast();
  const trackClick = useTrackClick();
  const handleSubmit = ({ content }: { content: string }) => {
    trackClick({
      type: 'button',
      name: '입점요청 상품 제출',
      properties: {
        content,
      },
    });
    toast('요청이 접수되었습니다');
  };

  return (
    <FormProvider onSubmit={handleSubmit}>
      {({ onSubmit, register, formState: { errors }, reset }) => {
        return (
          <form
            onSubmit={(e) => {
              onSubmit(e);
              reset();
            }}
          >
            <FormGroupControl
              required
              label="입점요청 상품"
              register={register}
              name="content"
              error={errors.content}
              className="mt-24"
            >
              <TextareaField />
            </FormGroupControl>
            <Button block type="submit" className="mt-4">
              의견 보내기
            </Button>
          </form>
        );
      }}
    </FormProvider>
  );
};

export default WishProductForm;
